import React from 'react';
import * as MuiIcons from '@mui/icons-material';
import useNavColors from './navColors';

import type { SvgIconComponent } from '@mui/icons-material';

interface NavIconProps {
    icon: string;
    isActive: boolean;
}

const NavIcon: React.FC<NavIconProps> = ({ icon, isActive }) => {
    const navColors = useNavColors();
    const Icon = MuiIcons[icon as keyof typeof MuiIcons] as SvgIconComponent | undefined;

    if (!Icon) return null;

    return (
        <Icon
            sx={{
                fontSize: '24px',
                color: isActive ? navColors.iconActiveColor : navColors.linkIconColor,
            }}
        />
    );
};

export default NavIcon;
